import Service from '@/api/service'

const initLoad = commit => commit('changeLoading', { isLoading: true })

const onCollectionSuccess = (commit, { scope, data }) => {
  commit('updateScope', { scope, services: data })
  commit('updateCollection', { collection: data })
  commit('changeLoading', { isLoading: false })
  return data
}

const onItemSuccess = (commit, { data }) => {
  commit('replaceItem', { item: data })
  commit('changeLoading', { isLoading: false })
  return data
}

const onError = (commit, { error }) => {
  commit('changeLoading', { isLoading: false })
  throw error
}

export default {
  fetchAll: ({ commit }, { scope = 'public' }) => {
    initLoad(commit)
    return Service.fetchAll({ scope })
      .then(({ data }) => onCollectionSuccess(commit, { scope, data }))
      .catch(error => onError(commit, { error }))
  },
  fetch: ({ commit }, { id }) => {
    initLoad(commit)
    return Service.get({ id })
      .then(({ data }) => onItemSuccess(commit, { data }))
      .catch(error => onError(commit, { error }))
  },
  update: ({ commit }, { id, data }) => {
    initLoad(commit)
    return Service.update({ id, data })
      .then(({ data }) => onItemSuccess(commit, { data }))
      .catch(error => onError(commit, { error }))
  },
  create: ({ commit }, { data }) => {
    initLoad(commit)
    return Service.create({ data })
      .then(({ data }) => onItemSuccess(commit, { data }))
      .catch(error => onError(commit, { error }))
  },
  remove: ({ commit }, { id }) => {
    initLoad(commit)
    return Service.remove({ id })
      .then(_ => onItemSuccess(commit, { data: { id } }))
      .catch(error => onError(commit, { error }))
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/services/actions.js